import { createFileRoute } from '@tanstack/react-router';

import { ChapterSearchClaimable } from '@/module/Author/Chapter/ChapterSearchClaimable';

export const Route = createFileRoute('/_auth/author/_author/chapter/_chapter/search-claimable')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ChapterSearchClaimable />;
}
